import type { ComponentPropsWithRef, ReactNode } from 'react';

import styles from './ui.module.css';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ComponentPropsWithRef<'button'> {
  readonly variant?: Variant;
  readonly size?: 'normal' | 'small';
  readonly icon?: ReactNode;
}

const VARIANT_CLASS: Record<Variant, string> = {
  primary: '',
  secondary: styles.secondary ?? '',
  ghost: styles.ghost ?? '',
  danger: styles.danger ?? '',
};

export function Button({ variant = 'primary', size = 'normal', icon, className, children, type = 'button', ...rest }: ButtonProps): React.JSX.Element {
  const classes = [styles.btn, VARIANT_CLASS[variant], size === 'small' ? styles.small : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <button type={type} className={classes} {...rest}>
      {icon}
      {children}
    </button>
  );
}

interface IconButtonProps extends ComponentPropsWithRef<'button'> {
  readonly label: string;
}

export function IconButton({ label, className, children, type = 'button', ...rest }: IconButtonProps): React.JSX.Element {
  return (
    <button type={type} className={[styles.iconBtn, className ?? ''].join(' ')} aria-label={label} title={label} {...rest}>
      {children}
    </button>
  );
}
